import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DOWNLOAD_DOCUMENT_FEATURE_KEY, DownloadDocumentState } from './download-document.reducer';

export const selectDownloadDocumentState = createFeatureSelector<DownloadDocumentState>(DOWNLOAD_DOCUMENT_FEATURE_KEY);

export const selectDownloadDocuments = createSelector(selectDownloadDocumentState, (state) => state.documents);

export const selectDownloadDocumentLoaded = createSelector(selectDownloadDocumentState, (state) => state.loaded);

export const selectDownloadDocumentError = createSelector(selectDownloadDocumentState, (state) => state.error);
